import { io } from "socket.io-client";

const socket = io("http://localhost:3014", {
  autoConnect: true,
  transports: ["websocket"],
});

socket.on("connect", () => {
  const userName = localStorage.getItem("user_name") || "Anonymous";
  socket.emit("register", userName);
});

export default socket;
